import { render, staticRenderFns } from "./PessoaCadastro.vue?vue&type=template&id=1f6f3ca8&scoped=true&"
import script from "./PessoaCadastro.vue?vue&type=script&lang=js&"
export * from "./PessoaCadastro.vue?vue&type=script&lang=js&"
import style0 from "./PessoaCadastro.vue?vue&type=style&index=0&id=1f6f3ca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f3ca8",
  null
  
)

export default component.exports